import { businessSchema, formatIssues, SLUG_RE, type Business } from '../utils/validation.ts';
import { AppError } from './errors.ts';

export interface TenantSummary {
  slug: string;
  name: string;
  city: string;
}

/** Validates raw config (from business.json or the DB) into a Business. */
export function parseBusiness(raw: unknown, slug: string): Business {
  const parsed = businessSchema.safeParse(raw);
  if (!parsed.success) {
    console.error(`Invalid config for "${slug}":\n${formatIssues(parsed.error).join('\n')}`);
    throw new AppError('invalid');
  }
  return parsed.data;
}

export function assertSlug(slug: string): void {
  if (!SLUG_RE.test(slug)) throw new AppError('not_found');
}

/** Promise cache that forgets failures, so a retry refetches. */
export function cached<T>(load: (key: string) => Promise<T>) {
  const cache = new Map<string, Promise<T>>();
  return {
    get(key: string): Promise<T> {
      let p = cache.get(key);
      if (!p) {
        p = load(key);
        p.catch(() => cache.delete(key));
        cache.set(key, p);
      }
      return p;
    },
    delete: (key: string) => cache.delete(key),
  };
}

export function tenantAsset(slug: string, file: string): string {
  return `/tenants/${slug}/images/${encodeURIComponent(file)}`;
}
